export default "__VITE_ASSET__6PKQhmA8__"